import { Component, ElementRef, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { FilterFieldGroup } from 'src/app/components/dialogs/select-filter-new/models/filter-field-group';
import { FieldDisplayType } from 'src/app/components/dialogs/select-filter-new/models/field-display-type';

@Component({
    selector: 'lex-field-search',
    templateUrl: './field-search.component.html',
    styleUrls: ['./field-search.component.scss'],
    standalone: false
})
export class FieldSearchComponent implements OnChanges {
  fieldControl: UntypedFormControl;
  filtered: Observable<FilterFieldGroup[]>;
  FieldDisplayType = FieldDisplayType;

  @Input() groups: FilterFieldGroup[] = [];
  @Output() optionSelected: EventEmitter<any>;
  @ViewChild('autoInput') autoInput: ElementRef;

  constructor() {
    this.fieldControl = new UntypedFormControl();
    this.optionSelected = new EventEmitter<any>();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.groups && (!changes.groups.previousValue || changes.groups.previousValue.length === 0) && changes.groups.currentValue.length >= 0) {
      // Groups is changing from nothing to something - set observable
      this.setFilteredObservable();
    }
  }

  setFilteredObservable() {
    this.filtered = this.fieldControl.valueChanges.pipe(
      startWith(''),
      map(value => {
        if (typeof value === 'string') return value;
        if (value.displayName) return value.displayName;
        if (value.groupName) return value.groupName;
      }),
      map((prefix: string) => this.getForPrefix(prefix))
    );
  }

  private getForPrefix(prefix: string): FilterFieldGroup[] {
    const show: FilterFieldGroup[] = [];

    const prefixLowered = prefix.toLowerCase();

    this.groups.forEach(g => {
      if (g.groupName.toLowerCase().includes(prefixLowered)) {
        show.push(g);
      } else {
        const matchingFields = g.fields.filter(f => f.displayName.toLowerCase().includes(prefixLowered));
        if (matchingFields.length > 0) show.push({ groupName: g.groupName, fields: matchingFields });
      }
    });

    return show;
  }

  /** a.k.a. blur */
  unFocus() {
    this.autoInput.nativeElement.blur();
  }
}
